import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  styled,
  Stack,
  Divider,
  Button,
  Avatar,
} from "@mui/material";
// import { GetCurrentAcademciSession } from "../helper/helper";
import { useApi } from "../store/UserLoginContext";

const StyledTableCell = styled(TableCell)({
  border: "1px solid black",
  padding: "2px",
  textAlign: "center",
  textAlign: "left",
  paddingLeft: "5px",
  fontSize: "12px",
});

const NewForm = (props, currentSessionAY, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        width: "297mm",
        minHeight: "210mm",
        // padding: "1mm",
        bgcolor: "#fff",
        color: "#000",
        fontSize: "13px", // slightly reduced
        lineHeight: 1.6,
        fontFamily: "serif",
        mb: "8mm",
      }}
    >
      <style>
        {`@media print {
          @page {
          size: A4 landscape;
          margin: 10mm;
          }
        }`}
      </style>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box width="100%" bgcolor="grey.100" p={1.5}>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mb={0}
          >
            <Grid item mt={-1} ml={4}>
              <img
                src="\img\ankuram_vp_logo.jpg"
                width={100}
                height={100}
                alt="School Logo"
              />
            </Grid>
            <Grid item xs textAlign="center" mr={8}>
              <Typography
                variant="h2"
                fontWeight="bold"
                textTransform="uppercase"
                p={0.5}
                pb={0}
              >
                ANKURAM VIDYAPEETH
              </Typography>
              <Typography variant="body1" mt={0} fontSize={"1em"}>
                NAWADIH, POST POLPOL, DALTONGANJ, DISTT. PALAMAU
              </Typography>
              <Typography variant="body2" fontSize={"1em"}>
                <strong> WHATSAPP:</strong> +91-7979851625{" "}
                <strong>E-MAIL: </strong>
                ankuramvidyapeeth@gmail.com
              </Typography>
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems={"center"}
            borderBottom={4}
            borderColor="black"
            py={1}
            mb={1}
          />
          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems={"center"}
            border={"2px solid black"}
            borderColor="black"
            py={1}
            mb={2}
            width={"100%"}
          >
            <Typography variant="h6" fontWeight={"bold"}>
              Due List of Class {props[0]?.class_name}-{props[0]?.section_name}{" "}
              upto{" "}
              {
                props[0]?.months_pending.academic_months.split(",")[
                  props[0]?.months_pending.academic_months.split(",").length - 1
                ]
              }
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Table for fee due report */}
      <Box style={{ margin: "2.5mm" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <strong>Sl.No</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Adm. No.</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Student Name</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Roll. No.</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Month</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Father Name</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Current Year Dues</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Previous Year Dues</strong>
                </StyledTableCell>
                <StyledTableCell>
                  <strong>Total Amt.</strong>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.map((item, index) => (
                <TableRow key={index}>
                  <StyledTableCell>{index + 1}</StyledTableCell>
                  <StyledTableCell>
                    {item.admission_id?.padStart(6, "0")}
                  </StyledTableCell>
                  <StyledTableCell>{item.name}</StyledTableCell>
                  <StyledTableCell>{item.roll_number}</StyledTableCell>
                  <StyledTableCell>
                    {item.months_pending?.academic_months}
                  </StyledTableCell>
                  <StyledTableCell>{item.father_name}</StyledTableCell>
                  <StyledTableCell>
                    {item.fee_breakdown.total_fee_due}
                  </StyledTableCell>
                  <StyledTableCell>{item.previous_year_dues}</StyledTableCell>
                  <StyledTableCell>
                    {item.fee_breakdown.total_fee_due + item.previous_year_dues}
                  </StyledTableCell>
                </TableRow>
              ))}
              <TableRow>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell colSpan={2}>Grand Total</StyledTableCell>
                <StyledTableCell>
                  {props.reduce(
                    (acc, el) => acc + el.fee_breakdown.total_fee_due,
                    0
                  )}
                </StyledTableCell>
                <StyledTableCell>
                  {props.reduce((acc, el) => acc + el.previous_year_dues, 0)}
                </StyledTableCell>
                <StyledTableCell>
                  {props.reduce(
                    (acc, el) =>
                      acc +
                      el.previous_year_dues +
                      el.fee_breakdown.total_fee_due,
                    0
                  )}
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

const feeDueMonthly = React.forwardRef(({ feeDueData }, ref) => {
  const { currentSessionAY } = useApi();

  return <div ref={ref}>{NewForm(feeDueData, currentSessionAY, ref)}</div>;
});

export default feeDueMonthly;
